import React from 'react';
import PropTypes from "prop-types";

import {styled} from "@mui/material/styles";

import {ReactComponent as DropdownChevron} from "assets/img/dropdown-chevron.svg";
import {greyishBlue300} from "assets/jss/main";

DropdownChevronIcon.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.number,
};

const StyledSvg = styled(DropdownChevron)(({ theme, color, disabled, size}) => ({
    ...size && {
        width: size,
        height: size
    },
    'path': {
        ...color !== null && {
            fill: color
        },
        ...disabled === true &&  {
            fill: greyishBlue300
        }
    },
}));

export default function DropdownChevronIcon(props) {
    return <StyledSvg {...props} />;
}
